import { api } from "jiffy-api";
import { EventBus, Events, store } from "jiffy-store";
import { changeCartName } from "components/jiffy/masthead-cart/masthead-cart";
import { track } from "jiffy-analytics";
import "./continue-shopping-modal-saved-carts-name.scss";

const $getCartNameContainer = () => document.querySelector(".js-modal-cart-name-container");
const $getCartName = () => document.querySelector(".js-continue-shopping-modal-cart-name");
const $$getModal = () => $("#continue-shopping-modal");
const $getEditNameButton = () => document.querySelector(".js-button-edit-cart-name");
const $getEditNameButtonOk = () => document.querySelector(".js-button-edit-cart-name-ok");
const $getEditNameButtonOkIcon = () => document.querySelector(".js-button-edit-cart-name-ok-icon");
const $getEditNameButtonCancel = () => document.querySelector(".js-button-edit-cart-name-cancel");
const $getEditNameForm = () => document.querySelector(".js-edit-cart-name-form");
const $getEditNameInput = () => document.querySelector(".js-modal-saved-cart-input");
const $getEditNameSpinner = () => document.querySelector(".js-edit-cart-name-spinner");
const $getEditNameError = () => document.querySelector(".js-modal-saved-cart-error");

const handleShowForm = () => {
  const $editNameInput = $getEditNameInput();

  $getCartNameContainer().classList.add("hidden");
  $getEditNameForm().classList.remove("hidden");

  $editNameInput.value = $getCartName().textContent;
  $editNameInput.select();
};

const setIsLoading = isLoading => {
  $getEditNameSpinner().classList.toggle("hidden", !isLoading);
  $getEditNameButtonOkIcon().classList.toggle("invisible", isLoading);
  $getEditNameInput().disabled = isLoading;
  $getEditNameButtonOk().disabled = isLoading;
  $getEditNameButtonCancel().disabled = isLoading;
};

const handleHideForm = () => {
  $getEditNameError().classList.add("hidden");
  $getEditNameInput().classList.remove("modal-saved-carts-name__input--error");
  $getEditNameForm().classList.add("hidden");
  $getCartNameContainer().classList.remove("hidden");
};

const showError = text => {
  const $editNameError = $getEditNameError();
  if (!$editNameError) return;

  $editNameError.textContent = text;
  $editNameError.classList.remove("hidden");
};

const publishNameChange = async newName => {
  const activeCart = store.get(state => state.pdp.activeCart);
  const cartNumber = activeCart.number;

  const response = await api.jiffyshirts.savedCart.update(
    { id: cartNumber },
    { saved_carts: { ...activeCart, cart_name: newName } }
  );

  if (!response || response.error) {
    showError("Something went wrong");
    return false;
  }

  EventBus.publish(Events.SAVED_CART_CHANGED, null, { cartNumber, newName });
  changeCartName(cartNumber, newName);
  $getCartName().textContent = newName;
  track("saved_carts_inline_edit_saved");
  return true;
};

const handleSubmitForm = async e => {
  e.preventDefault();
  if ($getEditNameInput().checkValidity() === false) {
    showError("Give a name to this cart.");
    return;
  }

  setIsLoading(true);
  const status = await publishNameChange($getEditNameInput().value);
  setIsLoading(false);
  if (status === false) return;

  handleHideForm();
};

const handleInvalidInput = ({ target: $target }) => {
  const isValid = $target.checkValidity();

  $target.classList.toggle("modal-saved-carts-name__input--error", !isValid);
  $getEditNameError().classList.toggle("hidden", isValid);
};

const initSavedCartsName = () => {
  $getCartNameContainer().classList.remove("hidden");
  if (!$getCartName()) return;
  $getEditNameButton().addEventListener("click", handleShowForm);
  $getEditNameButtonCancel().addEventListener("click", handleHideForm);
  $getEditNameButtonOk().addEventListener("click", handleSubmitForm);
  $getEditNameInput().addEventListener("change", handleInvalidInput);
  $$getModal().on("hide.bs.modal", handleHideForm);
};

store.pdp.changed(state => {
  const { activeCart } = state.pdp;
  if (!activeCart) return;

  const $cartName = $getCartName();
  if (!$cartName) return;

  $cartName.textContent = activeCart.cart_name;
});

export default initSavedCartsName;
